module.exports = __webpack_public_path__ + "static/media/temperature-up.2d46acd5.svg";